import {defineStore} from 'pinia'
import { ref } from 'vue'

export const useCartStore = defineStore("cart",()=>{
    const count = ref(0)
    const showCartPanel = ref(false)

    function setCount(newVal){
        count.value = newVal
    }
    function getCount(){
        return count.value
    }
    function openCart() {
        showCartPanel.value = true
    }
    function closeCart() {
        showCartPanel.value = false
    }
    return {count, showCartPanel, setCount, getCount, openCart, closeCart}
})